import * as React from 'react';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { RemovableBlockContainer } from './RemovableBlockContainer';
import SelectField from '../../../_common/platform/tsx/SelectField';
import { IDatasource } from '../../../pdc-platform/src/ts/stores/EntityModelsStore';
import { ParameterField } from './ParameterField';
import { QueryRootEntityField } from './QueryRootEntityField';

export default function DataSourceSelectorContainer(props: {
    datasources?: IDatasource[];
    selectedDataSourceID?: number;
    queryRootEntity?: string;
    id?: any;
    canBeRemoved?: boolean;
    canBeReordered?: boolean;
    showQueryRootEntityField?: boolean;
    children?: React.ReactNode | React.ReactNode[];
    glob?: IGlob;

    onDataSourceChange?(id: any, dataSourceID: number): void;
    onQueryRootEntityChange?(value: string, id: any): void;
    onRemove?(id: any): void;
}) {
    const handleOnRemove = () => {
        if (props.onRemove != null) {
            props.onRemove(props.id);
        }
    };

    const handleOnDataSourceChange = (selectedValue: string) => {
        if (props.onDataSourceChange != null) {
            const value = selectedValue != null ? parseInt(selectedValue) : null;

            props.onDataSourceChange(props.id, value);
        }
    };

    const dataSourceOptions = {
        values: [],
        display: []
    };

    if (props.datasources != null) {
        props.datasources.forEach((datasource) => {
            dataSourceOptions.values.push(datasource.dataSourceID.toString());
            dataSourceOptions.display.push(datasource.name);
        });
    }

    const selectedDataSourceID = props.selectedDataSourceID != null ? props.selectedDataSourceID.toString() : null;

    let queryRootEntityElement: React.JSX.Element;

    if (props.showQueryRootEntityField) {
        queryRootEntityElement = (
            <div className="ds-query-root-element">
                <QueryRootEntityField
                    value={props.queryRootEntity}
                    dataSourceID={props.selectedDataSourceID}
                    glob={props.glob}
                    onChange={(value: string) => {
                        if (props.onQueryRootEntityChange != null) {
                            props.onQueryRootEntityChange(value, props.id);
                        }
                    }}
                />
            </div>
        );
    }

    const dsContainer = (
        <div className="datasource-selector-container">
            <table className="ds-table">
                <tbody>
                    <tr>
                        <td>
                            <div className="ds-selector">
                                <ParameterField title={'Data Source'} clearable={false}>
                                    <SelectField
                                        value={selectedDataSourceID}
                                        options={dataSourceOptions}
                                        onChange={handleOnDataSourceChange}
                                    />
                                </ParameterField>
                            </div>

                            {queryRootEntityElement}
                        </td>
                    </tr>
                    <tr>
                        <td className="ds-container" colSpan={2}>
                            <div>{props.children}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

    if (props.canBeRemoved === false) {
        return dsContainer;
    } else {
        return (
            <RemovableBlockContainer showReorderButton={props.canBeReordered} onRemove={handleOnRemove}>
                {dsContainer}
            </RemovableBlockContainer>
        );
    }
}
